module.exports = __webpack_public_path__ + "img/advance-security-features.89942d0e.svg";